import React from "react";

const ImmortalChairperson = () => {
  return (
    <section className="bg-green-50 py-16 px-4 sm:px-6 lg:px-20">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-green-800 mb-4">
          Our Immortal Chairperson
        </h2>
        <p className="text-gray-700 text-lg mb-8">
          We bow at the Lotus Feet of <strong>H.H. Shri Mataji Nirmala Devi</strong>, the Founder of Sahaja Yoga,
          who eternally guides and inspires our Trust.
        </p>

        <div className="mx-auto max-w-md">
          <img
            src="/SHRIMATAJI.jpg" // ✅ Replace with correct path
            alt="Shri Mataji Nirmala Devi"
            className="w-full h-auto rounded-xl shadow-md border border-green-200"
          />
        </div>

        <p className="mt-6 italic text-green-700 font-medium">
          “You cannot know the meaning of your life until you are connected to the power that created you.”
        </p>
      </div>
    </section>
  );
};

export default ImmortalChairperson;
